import React from 'react';
import { formatCurrency, getCategoryBreakdown } from '../shared/constants';

const CategoryBreakdown = ({ expenses }) => {
	const { breakdown, total } = getCategoryBreakdown(expenses);

	const sortedCategories = Object.entries(breakdown).sort(
		([, a], [, b]) => b - a
	);

	return (
		<div className='bg-white rounded-lg border border-gray-200 p-6'>
			<h3 className='text-lg font-glacial font-bold text-clientBlack mb-4'>
				Category Breakdown
			</h3>

			<div className='space-y-3 mb-6'>
				{sortedCategories.length > 0 ? (
					sortedCategories.map(([category, amount]) => (
						<div key={category} className='flex items-center justify-between'>
							<div className='flex items-center flex-1'>
								<span className='text-sm font-montserrat text-clientBlack mr-3'>
									{category}
								</span>
								<div className='flex-1 h-2 bg-gray-100 rounded-full overflow-hidden'>
									<div
										className='h-full bg-primary'
										style={{
											width: `${(amount / total) * 100}%`,
										}}
									/>
								</div>
							</div>
							<span className='text-sm font-montserrat-medium text-clientBlack ml-4'>
								{formatCurrency(amount)}
							</span>
						</div>
					))
				) : (
					<p className='text-sm text-gray-500 font-montserrat'>
						No expenses for this period
					</p>
				)}
			</div>

			<div className='pt-4 border-t border-gray-200'>
				<div className='flex items-center justify-between'>
					<span className='text-base font-montserrat-medium text-clientBlack'>
						Total
					</span>
					<span className='text-xl font-montserrat-bold text-clientBlack'>
						{formatCurrency(total)}
					</span>
				</div>
			</div>
		</div>
	);
};

export default CategoryBreakdown;
